import { call } from 'redux-saga/effects';
import { user } from 'mz-sdk';
import { showErrorNotification, showSuccessNotification } from 'app/sagas/utils';
import getUser from './getUser';
import config from 'config';


export default function* doConfirmVerificationCode(action) {
  try {
    // Verify email
    const { key, domain } = action.payload;
    yield call(user.confirmEmail, { key, domain });
    yield call(getUser);
    yield call(showSuccessNotification, {
      messageId: 'USER.EMAIL_VERIFY.EMAIL_VERIFIED'
    });
    yield call(action.resolvePromise);

    // Full-page reload so nginx routes the destination correctly (e.g. / → transfer-next on www.mozio.com).
    // history.push would stay inside the mozio-web SPA and render the old homepage.
    window.location.href = config.SEARCH_REDIRECT_PATH; // eslint-disable-line require-atomic-updates
  } catch (error) {
    yield call(showErrorNotification, {
      messageId: 'USER.EMAIL_VERIFY.INVALID_EMAIL_VALIDATION_LINK'
    });
    yield call(action.rejectPromise);
  }
}
